import angular from 'angular';

const optionalKpis = [
  'nextUserIsMe',
  'blocked',
  'pastDeadline',
  'deadlineOneWeek',
  'deadlineTwoWeeks',
  'deadlineThreeWeeks',
];
const getWidgetClass = kpi => {
  switch (kpi) {
    case 'total':
      return 'info-block-dark';

    default:
      return 'info-block db-bg-ok';
  }
};
const getWidgetValueClass = kpi => {
  switch (kpi) {
    case 'blocked':
      return 'kpi-purple';
    case 'pastDeadline':
      return 'kpi-red';
    case 'deadlineOneWeek':
      return 'kpi-orange';
    case 'nextUserIsMe':
    case 'deadlineTwoWeeks':
    case 'deadlineThreeWeeks':
      return 'kpi-blue';
    default:
      return '';
  }
};

angular.module('cloudX').directive('cxRelTaskDashboard', [
  function() {
    return {
      restrict: 'E',
      template: require('./relTaskDashboard.html'),
      scope: { relation: '=' },
      controllerAs: 'vm',
      controller: [
        '$scope',
        '$state',
        '$http',
        'appUrls',
        '$filter',
        'checkSecurity',
        'invoiceDialogsSvc',
        function($scope, $state, $http, appUrls, $filter, checkSecurity, invoiceDialogsSvc) {
          const vm = this;
          if (!checkSecurity(['Todo:r', 'PlannedTask:r'])) return;
          vm.loading = false;
          vm.widgetList = [];
          vm.relation = $filter('compactRelation')($scope.relation);
          vm.relationId = $scope.relation.id;
          const getTaskKpis = () => {
            vm.loading = true;
            $http
              .get(`${appUrls.tasks}/api/plannedTasks/kpi`, {
                params: {
                  relationId: $scope.relation.id,
                },
              })
              .then(({ data }) => {
                vm.widgetList = [
                  {
                    kpi: 'total',
                    value: data.total ?? 0,
                    class: getWidgetClass('total'),
                    valueClass: getWidgetValueClass('total'),
                  },
                ];
                for (let i = 0; i < optionalKpis.length && vm.widgetList.length <= 5; i++) {
                  const kpi = optionalKpis[i];
                  const value = data[kpi] ?? 0;
                  if (value <= 0) continue;

                  vm.widgetList.push({
                    kpi,
                    value,
                    class: getWidgetClass(kpi),
                    valueClass: getWidgetValueClass(kpi),
                  });
                }

                vm.loading = false;
              });
          };

          if (checkSecurity(['PlannedTask:r'])) {
            getTaskKpis();
          }

          vm.getLabel = kpi => {
            switch (kpi) {
              case 'total':
                return $filter('translate')('Total');
              case 'nextUserIsMe':
                return $filter('translate')('Where i can start');
              case 'blocked':
                return $filter('translate')('Blocked');
              case 'pastDeadline':
                return $filter('translate')('PastDeadline');
              case 'deadlineOneWeek':
                return $filter('translate')('DeadlineOneWeek');
              case 'deadlineTwoWeeks':
                return $filter('translate')('DeadlineTwoWeeks');
              case 'deadlineThreeWeeks':
                return $filter('translate')('DeadlineThreeWeeks');
              default:
                return kpi;
            }
          };
        },
      ],
    };
  },
]);
